import { trackEvent } from 'analytics/analytics'
import type { FlightSearchItineraryLeg } from 'analytics/mapSnowplowSearchTracking'
import {
  mapFlightSearchParamsToFlightItineraryContext,
  mapFlightSearchParamsToSnowplowSearchContext,
} from 'analytics/mapSnowplowSearchTracking'
import { searchResultsEventWithContext } from 'analytics/snowplow/events'
import type { SnowplowEvent } from 'analytics/snowplow/events'
import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import uuidV4 from 'lib/string/uuidV4Utils'

export interface TrackFlightSearchCompletedParams {
  itinerary: Array<FlightSearchItineraryLeg>
  occupancies: Array<App.Occupants>
  fareClass: string
  fareType?: string
  searchId?: string
  flightFlow: 'standalone' | 'bundled'
  durationMs: number
  status: 'success' | 'error'
  resultCount?: number
  fromCache?: boolean
}

export function flightSearchCompletedSnowplowEvent(params: TrackFlightSearchCompletedParams): SnowplowEvent {
  const searchContext = mapFlightSearchParamsToSnowplowSearchContext({
    itinerary: params.itinerary,
    occupancies: params.occupancies,
    fareClass: params.fareClass,
    fareType: params.fareType,
    searchId: params.searchId,
    flightFlow: params.flightFlow,
  })
  const searchSessionId = uuidV4()

  const snowplowEvent = searchResultsEventWithContext({
    numberOfResults: params.resultCount ?? 0,
    searchContext,
    searchSessionId,
    status: params.fromCache ? undefined : params.status,
    durationMs: params.fromCache ? undefined : params.durationMs,
  })

  return {
    ...snowplowEvent,
    context: [
      ...(snowplowEvent.context ?? []),
      comluxgroup.createFlightItinerary_1_0_0(
        mapFlightSearchParamsToFlightItineraryContext({
          itinerary: params.itinerary,
          fareType: params.fareType,
        }),
      ),
    ],
  }
}

export function trackFlightSearchCompletedEvent(params: TrackFlightSearchCompletedParams): void {
  if (!params.itinerary.length) {
    return
  }

  trackEvent(flightSearchCompletedSnowplowEvent(params))
}
